import React, { Fragment, memo, PropsWithChildren, ReactNode } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from 'components/ui/card';
import { cn } from 'lib/utils';

interface Props extends PropsWithChildren {
  title?: string;
  shadow?: boolean;
  controls?: ReactNode[];
  dense?: boolean;
}

function Paper(props: Props) {
  const { title, shadow = false, controls, dense = false, children } = props;

  return (
    <Card className={cn(shadow && 'shadow-lg', dense && 'p-0')}>
      {!!title || !!controls ? (
        <CardHeader className="flex flex-row justify-between items-center gap-2 sm:gap-4 p-4 sm:p-6">
          {!!title && (
            <CardTitle className="text-base sm:text-lg">{title}</CardTitle>
          )}
          {!!controls && (
            <div className="flex flex-row gap-2 sm:gap-4 flex-wrap">
              {controls.map((control, controlIndex) => (
                <Fragment key={controlIndex.toString()}>{control}</Fragment>
              ))}
            </div>
          )}
        </CardHeader>
      ) : null}
      <CardContent
        className={cn((!!title || !!controls) && 'pt-0', 'p-4 sm:p-6')}
      >
        {children}
      </CardContent>
    </Card>
  );
}

export default memo(Paper);
